<template>
  <div class="pol-pod-drill-through-main">
    <div class="drill-through-body">
      <TableBox :title="tableTitle" :tableData="drillThroughDetails" :selectedRow.sync="selectedItem" :maxSelection="-1" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  components: {
    Tabulator
  },
  props: {
    drillThroughDetails: { type: Array, default: function() { return [] } },
    drillThroughType: { type: String, default: '' },
    tableTitle: { type: String, default: '' },
  },
  methods: {
    convertDate: function(data){
      for (var a=0; a<data.length; a++){
        var date = data[a]['Job Date'];
        if (date){
          var xformatedDate = new Date(parseInt(date.replace('/Date(','')));
          function pad(s) {
            return (s < 10 ) ? '0' + s :s; 
          }

        var d = new Date(xformatedDate);

        data[a]['Job Date']= [d.getFullYear(),pad(d.getMonth()+1),pad(d.getDate())].join('-');
        }
      }
    },
  },
  mounted() {
    console.log(this.$route.params.drillThroughName);
    var details = JSON.parse(sessionStorage.getItem(this.$route.params.drillThroughName));
    console.log(details);
    this.drillThroughDetails = details.data;
    this.drillThroughType = this.$route.params.drillThroughName.split('-')[1].trim().split(' ')[0].trim();

    

    if (details.port) {
      this.tableTitle = `${this.drillThroughType} LCL jobs for ${details.port}`;
    } else {
      this.tableTitle = `${this.drillThroughType} LCL summary by customer for ${details.country}`;
    }

    this.convertDate(this.drillThroughDetails);
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.pol-pod-drill-through-main {
  font-size: 12px;
  padding: 5px 45px;

  > .drill-through-body {
    background-color: white;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    padding: 5px;
  }
}
</style>